import { C } from '../../theme/palette';

export function FiligraneControls({ soc, setSoc }) {
  const set = (patch) => setSoc && setSoc((p) => ({ ...(p || {}), ...patch }));
  const f = soc?.filigrane || {};
  const fx = f.x ?? 50,
    fy = f.y ?? 44,
    ft = f.taille ?? 62,
    fo = f.opacite ?? 12,
    fr = f.rotation ?? 0;
  const lg = soc?.logo;
  const setF = (k, v) =>
    set({ filigrane: { x: fx, y: fy, taille: ft, opacite: fo, rotation: fr, [k]: Number(v) } });
  const setActif = (v) =>
    set({ filigrane: { x: fx, y: fy, taille: ft, opacite: fo, rotation: fr, actif: v } });
  const lab = {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 9,
    fontWeight: 700,
    color: C.grey,
    marginBottom: 3,
  };
  return (
    <div>
      <div
        onClick={() => setActif(!(f.actif !== false))}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          padding: '9px 11px',
          marginBottom: 11,
          background: C.navyXL,
          borderRadius: 9,
          cursor: 'pointer',
        }}
      >
        <span style={{ fontSize: 9.5, fontWeight: 700, color: C.ink }}>
          Afficher le logo en filigrane sur tous les documents
        </span>
        <div
          style={{
            width: 38,
            height: 22,
            minWidth: 38,
            borderRadius: 11,
            background: f.actif !== false ? C.green : '#cbd5e1',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 2,
              left: f.actif !== false ? 18 : 2,
              width: 18,
              height: 18,
              borderRadius: 9,
              background: '#fff',
            }}
          />
        </div>
      </div>
      <div
        style={{
          position: 'relative',
          width: 132,
          height: 186,
          margin: '0 auto 12px',
          background: '#fff',
          border: '1px solid ' + C.border,
          borderRadius: 6,
          overflow: 'hidden',
          boxShadow: '0 1px 5px rgba(0,0,0,.10)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 12,
            left: 12,
            width: 46,
            height: 5,
            background: '#cbd5e1',
            borderRadius: 3,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 26,
            left: 12,
            width: 74,
            height: 3,
            background: '#e5e7eb',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 34,
            left: 12,
            width: 64,
            height: 3,
            background: '#e5e7eb',
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: 14,
            right: 12,
            width: 54,
            height: 14,
            background: C.navy,
            borderRadius: 3,
          }}
        />
        {lg ? (
          <img
            src={lg}
            alt=""
            style={{
              position: 'absolute',
              top: fy + '%',
              left: fx + '%',
              transform: 'translate(-50%,-50%) rotate(' + fr + 'deg)',
              width: ft + '%',
              objectFit: 'contain',
              opacity: fo / 100,
            }}
          />
        ) : (
          <div
            style={{
              position: 'absolute',
              top: fy + '%',
              left: fx + '%',
              transform: 'translate(-50%,-50%) rotate(' + fr + 'deg)',
              fontSize: 12,
              fontWeight: 900,
              color: C.navy,
              opacity: Math.max(0.1, fo / 100),
              whiteSpace: 'nowrap',
            }}
          >
            {soc?.nom || 'LOGO'}
          </div>
        )}
      </div>
      <div style={{ marginBottom: 9 }}>
        <div style={lab}>
          <span>↔ Position horizontale</span>
          <span>{fx} %</span>
        </div>
        <input
          type="range"
          min={5}
          max={95}
          value={fx}
          onChange={(e) => setF('x', e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginBottom: 9 }}>
        <div style={lab}>
          <span>↕ Position verticale</span>
          <span>{fy} %</span>
        </div>
        <input
          type="range"
          min={5}
          max={95}
          value={fy}
          onChange={(e) => setF('y', e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginBottom: 9 }}>
        <div style={lab}>
          <span>⤢ Taille</span>
          <span>{ft} %</span>
        </div>
        <input
          type="range"
          min={20}
          max={100}
          value={ft}
          onChange={(e) => setF('taille', e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginBottom: 9 }}>
        <div style={lab}>
          <span>◐ Intensité</span>
          <span>{fo} %</span>
        </div>
        <input
          type="range"
          min={3}
          max={40}
          value={fo}
          onChange={(e) => setF('opacite', e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ marginBottom: 7 }}>
        <div style={lab}>
          <span>⤡ Inclinaison (diagonale)</span>
          <span>{fr}°</span>
        </div>
        <input
          type="range"
          min={-90}
          max={90}
          step={5}
          value={fr}
          onChange={(e) => setF('rotation', e.target.value)}
          style={{ width: '100%' }}
        />
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 9 }}>
        {[
          ['Droit', 0],
          ['Diagonale ↗', -45],
          ['Diagonale ↘', 45],
        ].map(([lb, deg]) => (
          <button
            key={lb}
            onClick={() => setF('rotation', deg)}
            style={{
              flex: 1,
              border: '1px solid ' + C.border,
              background: fr === deg ? C.navy : '#fff',
              color: fr === deg ? '#fff' : C.navy,
              borderRadius: 8,
              padding: '7px 4px',
              fontSize: 8.5,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {lb}
          </button>
        ))}
      </div>
      <button
        onClick={() => set({ filigrane: { x: 50, y: 44, taille: 62, opacite: 12, rotation: 0 } })}
        style={{
          background: 'none',
          border: 'none',
          color: C.navy,
          fontSize: 9.5,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        ↺ Réinitialiser la position
      </button>
      {!lg && (
        <div style={{ fontSize: 8, color: C.muted, marginTop: 6 }}>
          Charge ton logo (Réglages → Société) pour le voir en filigrane.
        </div>
      )}
    </div>
  );
}
